import * as api from '../../../clients/qschecks';

import {Action} from '@ngrx/store';

export const GET_QS_CHECKS_MANDANT_OPTIONS = '[QschecksModul] GetQsChecksMandantOptions laden';
export const GET_QS_CHECKS_MANDANT_OPTIONS_AUSFUEHREN = '[QschecksModul] GetQsChecksMandantOptions ausführen';
export const GET_QS_CHECKS_MANDANT_OPTIONS_ERFOLGREICH = '[QschecksModul] GetQsChecksMandantOptions laden erfolgreich';
export const GET_QS_CHECKS_MANDANT_OPTIONS_FEHLER = '[QschecksModul] GetQsChecksMandantOptions Ladefehler';
export const GET_QS_CHECKS_MANDANT_OPTIONS_NICHT_AUSGEFUEHRT = '[QschecksModul] GetQsChecksMandantOptions nicht ausgeführt (evtl. Offline)';


export class GetQsChecksMandantOptionsAction implements Action {
    readonly type = GET_QS_CHECKS_MANDANT_OPTIONS;
        constructor(public optPayload: any = null) {}
    }
export class GetQsChecksMandantOptionsAusfuehrenAction implements Action {
    readonly type = GET_QS_CHECKS_MANDANT_OPTIONS_AUSFUEHREN;
        constructor(public optPayload: any = null) {}
    }
export class GetQsChecksMandantOptionsErfolgreichAction implements Action {
    readonly type = GET_QS_CHECKS_MANDANT_OPTIONS_ERFOLGREICH;
        constructor(public payload: api.QsChecksMandantOptions, public optPayload: any = null) {}
    }
export class GetQsChecksMandantOptionsFehlerAction implements Action {
    readonly type = GET_QS_CHECKS_MANDANT_OPTIONS_FEHLER;
        constructor(public payload: any, public optPayload: any = null) {}
    }
export class GetQsChecksMandantOptionsNichtAusgefuehrtAction implements Action {
    readonly type = GET_QS_CHECKS_MANDANT_OPTIONS_NICHT_AUSGEFUEHRT;
        constructor(public optPayload: any = null) {}
    }
    

export type QschecksQueryQsChecksMandantOptionsActions =
    GetQsChecksMandantOptionsAction
    | GetQsChecksMandantOptionsAusfuehrenAction
    | GetQsChecksMandantOptionsErfolgreichAction
    | GetQsChecksMandantOptionsFehlerAction
    | GetQsChecksMandantOptionsNichtAusgefuehrtAction
    ;
